<template>
  <b-card
    v-if="data"
    no-body
    class="card-revenue-budget"
  >
    <b-row class="mx-0">
      <b-col
        md="12"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-3">
          <h4
            title="'Tooltip text here'"
            class="card-title mb-50 mb-sm-0 chart-title"
          >
            {{ $t('Monthly Earnings') }}
            <feather-icon
              v-b-tooltip.hover.v-primary="'This chart illustrates the cumulative sum of delivery charge for all orders which has been invoiced on the respective month. It specifically displays data from the past 12 months.'"
              icon="HelpCircleIcon"
              size="15"
              class="cursor-pointer text-primary"
            />
          </h4>
          <b-button
            v-if="showRefreshButton"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            class="widgetrefresh-button d-sm-flex align-items-center justify-content-center shadow-custom"
            :style="cardBorder"
            @click="refreshWidget"
          >
            <feather-icon
              icon="RefreshCwIcon"
              class="mr-50 refresh-icon"
            />
            <span class="align-middle refresh-span" />
            <time-ago
              class="timeAgo"
              :datetime="lastUpdatedAt"
              refresh
              locale="en"
              :long="longString"
              :style="{color: '#1C1F32'}"
            />
          </b-button>
        </div>

        <!-- chart -->
        <vue-apex-charts
          id="revenue-report-chart"
          height="230"
          :options="chartOptions"
          :series="data.series"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, VBTooltip, BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Ripple from 'vue-ripple-directive'
import { TimeAgo } from 'vue2-timeago'
import RefreshMixin from '@/@core/mixins/ui/refresh'

export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
    TimeAgo,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [RefreshMixin],
  props: {
    data: {
      type: Object,
      default: () => {
      },
    },
    lastUpdatedAt: {
      type: String,
      default: null,
    },
    queue: {
      type: String,
      required: true,
    },
    showRefreshButton: {
      type: Boolean,
      default: true, // or false, depending on your default preference
    },
  },
  data() {
    return {
      currencyType: '',
      revenue_report: {},
      chartOptions: {
        chart: {
          type: 'area',
          toolbar: { show: false },
          zoom: { enabled: true },
          width: 737,
          height: 288,
        },
        colors: ['#0094FF'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: 'straight',
          dashArray: [0, 8, 5],
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.5,
            gradientToColors: ['#ECF6FF'], // Lighter blue for gradient
            inverseColors: false,
            opacityFrom: 0.8,
            opacityTo: 0.5,
            stops: [0, 100],
          },
        },
        grid: {
          padding: {
            top: -20,
          },
        },
        tooltip: {
          enabled: true,
          custom({ series, seriesIndex, dataPointIndex }) {
            const value = series[seriesIndex][dataPointIndex]
            const formattedValue = value.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
            return `
              <div
                class="custom-tooltip"
                style="
                  padding: 4px 12px;
                  background: #0094FF;
                  color: #FFF;
                  border-radius: 20px;
                  font-size: 14px;
                  font-weight: 600;
                "
              >
                <span>${formattedValue}</span>
              </div>
            `
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        responsive: [
          {
            breakpoint: 767,
            options: {
              xaxis: {
                categories: this.data.categories.lables,
                labels: {
                  rotate: -45,
                  rotateAlways: true,
                },
              },
            },
          },
        ],
        xaxis: {
          categories: this.data.categories.lables,
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: false,
            showDuplicates: false,
            trim: false,
            maxHeight: 250,
            style: {
              colors: [],
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 900,
              cssClass: 'apexcharts-xaxis-label',
            },
          },
        },
        yaxis: {
          labels: {
            formatter: value => value.toLocaleString('en-us', {
              style: 'currency',
              currency: `${this.currencyType}`,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
          },
          style: {
            colors: '#6E6B7B',
            fontSize: '0.86rem',
            fontFamily: 'Montserrat',
          },
        },
      },
      longString: true,
    }
  },
  computed: {
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
  },
  created() {
    this.setCurrencyType()
  },
  methods: {
    setCurrencyType() {
      this.currencyType = localStorage.getItem('businessCurrency')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../@core/scss/vue/pages/widget-refresh.scss';
.refresh-icon {
  color: #1C1F32;
}
</style>
